import { createContext, useContext } from 'react'

import type { SearchPage } from '../lib/page-search.ts'
import type { InternalPage, InternalNavSection } from '../lib/pages.ts'

export interface LandingNavigation {
  sections: readonly InternalNavSection[]
  pages: readonly SearchPage[]
  starredPages: readonly InternalPage[]
  recentPages: readonly InternalPage[]
  /** Merchant 360's path when this viewer may open it. Null hides that search. */
  merchant360Path: string | null
  openCustomization: () => void
}

export const LandingNavigationContext = createContext<LandingNavigation | null>(
  null
)

/** The root layout supplies the same accessible sections to the rail and home. */
export function useLandingNavigation(): LandingNavigation {
  const navigation = useContext(LandingNavigationContext)
  if (navigation === null) {
    throw new Error('The landing page needs the internal navigation layout')
  }
  return navigation
}
